import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {BrandEnum} from './brand'
import {PersonalisationRuleSchema} from './personalisationRule'

export const DetailsTemplateSettingsSchema = buildEntrySchemaFor('detailsTemplateSettings', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      brand: safeOptional(BrandEnum),
      heroCtaOnePersonalisation: safeOptional(z.array(PersonalisationRuleSchema)),
      heroCtaTwoPersonalisation: safeOptional(z.array(PersonalisationRuleSchema)),
      experiments: safeOptional(z.record(z.string(), z.unknown())),
    }),
  ),
})
export type DetailsTemplateSettings = z.infer<typeof DetailsTemplateSettingsSchema>
